import React, { useMemo } from 'react';
import InView from '../../../components/Shared/InView';
import Styles from './styles';
import Form from './Form';
import V1 from './V1';
import V2 from './V2';
import V3 from './V3';
import V4 from './V4';
import V5 from './V5';
import noop from '../../../util/noop';

interface Content {
  heroVersion?: string;
  heroImage?: {
    fields: {
      title?: string;
      description?: string;
      file?: {
        url?: string;
      };
    };
  };
  mobileHeroImage?: {
    fields: {
      title?: string;
      description?: string;
      file?: {
        url?: string;
      };
    };
  };
  homeData?: {
    baths: number;
    beds: number;
    modelDescription: string;
    maxSquareFeet: number;
  };
  header?: string | null;
  subHeader?: string;
  largeHeader?: string;
  secondaryHeader?: string;
  intro?: string;
  disclaimer?: string;
  webForm?: {
    contentfulName?: string;
    formHeader?: string;
    formSubHeader?: string;
    formIntro?: string;
    formContactFields?: string[];
    disclaimer?: string;
    disclaimerCheckbox?: boolean;
    firstFormButtonText?: string;
    firstFormButtonURL?: string;
    buttonAndTextColors?: string;
    secondFormButtonText?: string;
    secondFormButtonURL?: string;
    secondButtonColor?: string;
    originWebFormType?: string;
    originCampaign?: string;
    originWebFormCategory?: string;
    secondOriginWebFormCategory?: string;
    originWebPageType?: string;
    originWebApp?: string;
    dataExtension?: string;
  };
  webFormImage?: {
    fields?: {
      description?: string;
      file?: {
        url?: string;
      };
    };
  } | null;
  heroBackgroundColor?: string;
  inView?: boolean;
}

interface HeaderProps {
  isSubmittingForm?: boolean;
  onSubmittingFormChange?: (isSubmitting: boolean) => void;
  content?: Content;
  triggerGTMEvent?: () => void;
}

const headerVersions = {
  V1: 'V1: Home Data',
  V2: 'V2: Promo Callout',
  V3: 'V3: No Payment',
  V4: 'V4: Basic',
  V5: 'V5: Full Image Basic',
};

const Header: React.FC<HeaderProps> = ({
  isSubmittingForm = false,
  onSubmittingFormChange = noop,
  content,
  triggerGTMEvent = () => noop,
}) => {
  const HeaderVersion = useMemo(() => {
    if (!content?.heroVersion) return null;

    switch (content.heroVersion) {
      case headerVersions.V1:
        return V1;
      case headerVersions.V2:
        return V2;
      case headerVersions.V3:
        return V3;
      case headerVersions.V4:
        return V4;
      case headerVersions.V5:
        return V5;
      default:
        return null;
    }
  }, [content]);

  if (!content || !HeaderVersion) return <></>;

  return (
    <InView shouldAnimate={true}>
      <Styles>
        <HeaderVersion
          content={content}
          homeData={content?.homeData}
          inView={content?.inView}
        />
        <Form
          webForm={content?.webForm}
          imageAlt={content?.webFormImage?.fields?.description}
          imageSrc={content?.webFormImage?.fields?.file?.url}
          isSubmittingForm={isSubmittingForm}
          onSubmittingFormChange={onSubmittingFormChange}
          triggerGTMEvent={triggerGTMEvent}
        />
      </Styles>
    </InView>
  );
};

export default Header;
